var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('span',[_vm._v("Made with Vue and Vue Bootstrap. Deployed on Netlify.")]),_c('p',[_vm._v("© 2024 Fernanda Toledo")])])])
}]

export { render, staticRenderFns }